import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      GIFT_CARD: "Gavekort",
      GIFTCARD_PURCHASED: "Gavekort kjøpt!",
      WE_HAVE_SENT_YOU_AN_EMAIL: "Vi har sendt gavekortet til ",
      YOU_CAN_FORWARD_IT_DIRECTLY_OR_PRINT:
        "Du kan videresende den direkte eller skrive den ut og gi den bort.",
      BUY_A_NEW_GIFTCARD: "Kjøp et gavekort til",
    },
    se: {
      GIFT_CARD: "Presentkort",
      GIFTCARD_PURCHASED: "Köpet är genomfört!",
      WE_HAVE_SENT_YOU_AN_EMAIL: "Vi har skickat presentkortet till ",
      YOU_CAN_FORWARD_IT_DIRECTLY_OR_PRINT:
        "Vidarebefordra presentkortet eller skriv ut och ge bort det.",
      BUY_A_NEW_GIFTCARD: "Köp ett presentkort till",
    },
    dk: {
      GIFT_CARD: "Gavekort",
      GIFTCARD_PURCHASED: "Gavekort købt!",
      WE_HAVE_SENT_YOU_AN_EMAIL: "Vi har sendt gavekortet til ",
      YOU_CAN_FORWARD_IT_DIRECTLY_OR_PRINT:
        "Du kan videresende det direkte eller printe det ud og give det til modtageren fysisk.",
      BUY_A_NEW_GIFTCARD: "Køb flere gavekort",
    },
  } as const
)[language];
